var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNewPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 448,
    height: 310,
    viewBox: "0 0 448 310",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#b);}.b{fill:#535461;}.c{opacity:0.1;}.d{opacity:0.17;}.e{opacity:0.05;}.f{opacity:0.07;}.g{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 310
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 448,
    height: 310
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.34 -148.447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M456.142,326.558,368.88,305.54V470.013l87.262-22.842Z",
    transform: "translate(-231.19 -65.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M456.142,326.558,368.88,305.54V470.013l87.262-22.842Z",
    transform: "translate(-231.19 -65.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.83,326.558l87.258-21.018V470.013L128.83,447.625Z",
    transform: "translate(-78.398 -65.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M128.83,324.558l87.258-21.018v165.2L128.83,446.352Z",
    transform: "translate(-78.398 -64.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M366.88,240.669l45.957-38.189L500.1,224.868l-45.957,36.819Z",
    transform: "translate(-229.917 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.66,227.322,52.432,262.96l87.258-21.018L95.376,204.48Z",
    transform: "translate(-1.273 -1.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M5.66,225.322l45.863,36.364,87.258-21.018-45.4-38.189Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M125.69,428.981l48.883,12.334,39.291-31.981V389.69L126.6,367.76Z",
    transform: "translate(-76.399 -105.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M456.434,428.981l-48.883,12.334L368.26,409.333V389.69l87.262-21.93Z",
    transform: "translate(-230.795 -105.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.432,363.36l-44.772,37,87.258,21.93L137.69,386.66Z",
    transform: "translate(0 -102.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M456.142,363.36l45.23,37-86.8,21.93L368.88,386.66Z",
    transform: "translate(-231.19 -102.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M456.142,363.36l45.23,37-86.8,21.93L368.88,386.66Z",
    transform: "translate(-231.19 -102.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNewPlans);
export default __webpack_public_path__ + "static/media/no_new_plans.3861e5f826de5339d6df8a5e871f6944.svg";
export { ForwardRef as ReactComponent };